var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DPill',{attrs:{"label":_vm.pillInfo.label,"icon":_vm.pillInfo.icon,"color":_vm.pillInfo.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }